import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import Login from "./containers/Login";
import Logout from "./containers/Logout";
import NotFound from "./containers/NotFound";
import AppliedRoute from "./components/AppliedRoute";
import Signup from "./containers/Signup";
import Profile from "./containers/Profile";
import Library from "./containers/Library";
import AddBook from "./containers/AddBook";
import Friend from "./containers/Friend";
import Friends from "./containers/Friends";
import Terms from "./containers/Terms";
import PrivacyPolicy from "./containers/PrivacyPolicy";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

export default ({ childProps }) => (
  <Switch>
    <AppliedRoute path="/" exact component={Home} props={childProps} />
    <Route
      path="/privacypolicy"
      exact
      component={PrivacyPolicy}
      props={childProps}
    />
    <Route path="/terms" exact component={Terms} props={childProps} />
    <UnauthenticatedRoute
      path="/login"
      exact
      component={Login}
      props={childProps}
    />
    <UnauthenticatedRoute
      path="/logout"
      exact
      component={Logout}
      props={childProps}
    />
    <Route path="/signup" exact component={Signup} props={childProps} />
    <AuthenticatedRoute
      path="/user/profile"
      exact
      component={Profile}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/user"
      exact
      component={Profile}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/user/search"
      exact
      component={Profile}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/library"
      exact
      component={Library}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/library/add"
      exact
      component={AddBook}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/friends/:userid"
      exact
      component={Friend}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/friends"
      exact
      component={Friends}
      props={childProps}
    />

    {/* Finally, catch all unmatched routes */}
    <Route component={NotFound} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/Routes.js